import { render, staticRenderFns } from "./Sterlization.vue?vue&type=template&id=281a0570&scoped=true&"
import script from "./Sterlization.vue?vue&type=script&lang=js&"
export * from "./Sterlization.vue?vue&type=script&lang=js&"
import style0 from "./Sterlization.vue?vue&type=style&index=0&id=281a0570&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281a0570",
  null
  
)

export default component.exports